import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import { SortModalType } from '@/tsort/enum/sort-modal-type.enum';
import './sorting-modal.component.scss';
import { DisplayTask, GetTaskResponse } from '@/tsort/model/response/get-task-response.model';
import AlertMessageComponent from '@/common/components/alert-message/alert-message.component';
import TooltipComponent from '@/common/components/tooltip/tooltip.component';
import { ChuteModeType } from '@/tsort/enum/chute-mode-type.enum';
import { SortingTable } from '@/tsort/model/sorting-table';
import { WorkTypeSorting } from '@/tsort/enum/work-type-sorting.enum';
import { namespace } from 'vuex-class';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { ScanMode } from '@/common/enum/scan-mode.enum';
import { WorkInstruction } from '@/tsort/enum/work-instruction.enum';
import SortingUtils from '@/common/utils/sorting.util';

// ストアモジュール
const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
@Component({})
export default class SortingModal extends Vue {
  @Prop() title!: string;
  @Prop() isShow!: boolean;
  @Prop() type!: string;
  @Prop() scanCodeInput!: string;
  @Prop() fieldNameScanCode!: string;
  @Prop() targetTaskList!: DisplayTask[];
  @Prop() targetTask!: GetTaskResponse;
  @Prop() currentTaskListIndex!: number;
  @Prop() scanCodePattern!: string;
  @Prop() chuteModeType!: ChuteModeType;
  @Prop() lastChuteNo!: string;
  @Prop() dataSortingTable!: Array<SortingTable>;
  @Prop({ default: true }) displayNumericKeyboard!: boolean;
  @Prop() inputQuantity!: string;
  @Prop() maxInputQuantity!: number;
  @Prop() inputQuantityStore!: number[];
  @Prop() modeType!: ScanMode;
  @Prop() modalScan!: string;

  isShowData = false;

  @SortStore.Getter
  workTypeSorting!: WorkTypeSorting;

  @SortStore.Getter
  workInstruction!: WorkInstruction;

  closeModal() {
    this.$bvModal.hide('sortModal');
  }
  @Emit('acceptBtn')
  accept(): void {
    this.closeModal();
    return;
  }
  @Emit('exitBtn')
  exit(): void {
    return;
  }

  @Watch('isShow')
  isShowWatcher(): void {
    this.isShowData = this.isShow;
  }

  @Emit('backTaskList')
  backTaskList(): void {
    return;
  }

  @Emit('nextTaskList')
  nextTaskList(): void {
    return;
  }

  checkDifferentInputQuantity(): boolean {
    if (
      this.inputQuantityStore.length < 1 ||
      (this.chuteModeType === ChuteModeType.ON && this.dataSortingTable.length < 1)
    ) {
      return false;
    }
    const remainingQty =
      this.chuteModeType === ChuteModeType.OFF
        ? this.maxInputQuantity
        : this.dataSortingTable[this.dataSortingTable.length - 1]?.numberOfTasks;
    return this.inputQuantityStore[0] > remainingQty;
  }

  get isMultiSortingAndOneHunderPercentMode(): boolean {
    return SortingUtils.isMultiSorting && this.modeType === ScanMode.ONE_HUNDRED_PERCENT_SCAN;
  }

  isShowMaxInputQuantity(): boolean {
    return (
      (SortingUtils.isMultiSorting && this.chuteModeType === ChuteModeType.OFF) || SortingUtils.isNoWorkInstruction
    );
  }

  render() {
    return (
      <div v-frag>
        {/* CONFIRM MODAL */}
        {this.type === SortModalType.CONFIRM ? (
          <b-modal
            id="normal-sort-modal"
            v-model={this.isShowData}
            size="md"
            centered
            no-close-on-backdrop={true}
            hide-footer
            hide-header
          >
            <h4 class="text-center font-weight-bold pb-4 pt-3 align-title-modal">{this.title}</h4>
            <slot></slot>
            <p class="text-center gray-small-text text-break">
              {this.fieldNameScanCode} : {this.scanCodeInput}
            </p>
            <b-container fluid class="pt-5">
              <b-row class="h-100">
                <b-col cols="6" class=" d-flex  justify-content-center align-items-end">
                  <b-button onClick={() => this.exit()}>閉じる</b-button>
                </b-col>
                <b-col cols="6" class=" d-flex justify-content-center">
                  <b-button class="accept-btn" on-click={() => this.accept()}>
                    発進
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-modal>
        ) : null}

        {/* CANCEL MODAL */}
        {this.type === SortModalType.CANCEL ? (
          <b-modal
            id="normal-sort-modal"
            v-model={this.isShowData}
            centered
            size="md"
            no-close-on-backdrop={true}
            hide-footer
            hide-header
          >
            <h4 class="text-center font-weight-bold pb-4 pt-3">本当に前の投入をキャンセルしてよろしいですか？</h4>
            <p class="text-center gray-small-text">キャンセル後に再スキャンしてください。</p>
            <b-container fluid class="pt-5">
              <b-row class="h-100">
                <b-col cols="6" class="d-flex justify-content-center">
                  <b-button onClick={() => this.exit()} class="exit-btn ">
                    いいえ
                  </b-button>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-center">
                  <b-button class="accept-btn" on-click={() => this.accept()}>
                    はい
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-modal>
        ) : null}

        {this.type === SortModalType.SCAN ? (
          <b-modal
            id="sortModal2"
            modal-class={`sorting-modal ${this.modalScan}`}
            v-model={this.isShowData}
            size="lg"
            centered
            ref="sortModal2"
            no-close-on-backdrop={true}
            hide-footer
            hide-header
          >
            <template class="modal-header d-flex flex-column no-border">
              <button class="close float-right" onClick={() => this.exit()}>
                <span class="material-icons md-dark cursor-pointer">close</span>
              </button>
              <h3 class="font-weight-bold mx-auto title">{this.title}</h3>
            </template>
            <b-container fluid class="px-0">
              <AlertMessageComponent />
              {this.targetTaskList[this.currentTaskListIndex]?.scanMessage && (
                <div class="custom-scan-message">
                  <TooltipComponent
                    ref="scan-code-message-tooltip"
                    idLabelEllipsis="scan-code-message"
                    customClass="label-scan-message"
                    labelEllipsis={this.targetTaskList[this.currentTaskListIndex]?.scanMessage}
                  />
                </div>
              )}
              <div class="row">
                <div
                  class={{
                    'col-12': true,
                    'col-lg-8': this.displayNumericKeyboard
                  }}
                >
                  <b-container fluid>
                    <b-container fluid class="d-flex w-100 mt-3 mb-2">
                      {/* ON Mode */}
                      {(SortingUtils.isHandSorting ||
                        SortingUtils.isNoWorkInstruction ||
                        this.chuteModeType === ChuteModeType.ON) && (
                        <b-col class="col-6 pl-4">
                          <p class="text-center font-weight-normal mb-1">シュートNo</p>
                          <b-container>
                            <b-col class="d-flex justify-content-between align-items-center">
                              <b-button
                                class={{
                                  'backBtn align-items-center cursor-pointer': true,
                                  invisible: this.currentTaskListIndex == 0
                                }}
                                on-click={() => this.backTaskList()}
                              >
                                <span class="material-icons md-white align-middle cursor-pointer font-weight-bold">
                                  arrow_back
                                </span>
                              </b-button>
                              <h4 class="text-center font-weight-bold mx-2 mb-0">
                                {this.targetTaskList[this.currentTaskListIndex || 0]?.chuteNo}
                              </h4>
                              <b-button
                                class={{
                                  'forwardBtn cursor-pointer': true,
                                  invisible: this.currentTaskListIndex == this.targetTaskList.length - 1
                                }}
                                on-click={() => this.nextTaskList()}
                              >
                                <span class="material-icons md-white align-middle cursor-pointer font-weight-bold">
                                  arrow_forward
                                </span>
                              </b-button>
                            </b-col>
                          </b-container>
                        </b-col>
                      )}
                      <b-col
                        cols={SortingUtils.isParallelMultiSorting && this.chuteModeType === ChuteModeType.OFF ? 12 : 6}
                        id="column-product"
                      >
                        <p class="text-center font-weight-normal mb-1">
                          <TooltipComponent
                            ref="scan-code-pattern-lable-tooltip"
                            customClass="field-name-scan-code-lable"
                            idLabelEllipsis="field-name-scan-code-lable"
                            labelEllipsis={SortingUtils.isMultiSorting ? '商品' : this.fieldNameScanCode}
                          />
                        </p>
                        <h4 class="w-100 text-center font-weight-bold">
                          <TooltipComponent
                            ref="info-production-tooltip"
                            customClass="info-production"
                            idLabelEllipsis="info-production"
                            labelEllipsis={
                              SortingUtils.isHandSorting
                                ? this.scanCodePattern
                                : this.targetTaskList[this.currentTaskListIndex]?.itemName ||
                                  this.targetTaskList[this.currentTaskListIndex]?.itemNo ||
                                  this.scanCodePattern
                            }
                          />
                        </h4>
                      </b-col>
                    </b-container>
                    <b-container
                      fluid
                      class={{
                        'table-info-wrapper pb-3': true,
                        'custom-table-info-wrapper': this.isMultiSortingAndOneHunderPercentMode,
                        'custom-height-table-info-wrapper':
                          SortingUtils.isNoTaskMultiSorting && this.modeType === ScanMode.REPRESENTATIVE_SCAN
                      }}
                    >
                      <b-row>
                        <div class={{ 'col-lg-9': this.isMultiSortingAndOneHunderPercentMode }}>
                          <table class="table table-striped">
                            {SortingUtils.isParallelSorting ? (
                              <thead>
                                <tr class="text-center">
                                  <th scope="col"></th>
                                  <th scope="col">タスク数</th>
                                  <th class="operaSign" scope="col">
                                    x
                                  </th>
                                  <th scope="col">出荷単位</th>
                                  <th class="operaSign" scope="col">
                                    =
                                  </th>
                                  <th scope="col">総バラ数</th>
                                </tr>
                              </thead>
                            ) : (
                              <thead>
                                <tr class="text-center">
                                  <th scope="col"></th>
                                  <th scope="col">タスク数</th>
                                  <th scope="col"></th>
                                  <th scope="col"></th>
                                  <th scope="col"></th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                            )}
                            <tbody class="text-center">
                              {this.dataSortingTable.map((data, index) => {
                                return (
                                  <tr
                                    key={index}
                                    class={{
                                      'bg-white': SortingUtils.isHandSorting && this.modeType
                                    }}
                                  >
                                    <th scope="row" class="align-middle text-left">
                                      {data?.columnName}
                                    </th>
                                    <td class="text-center px-0">
                                      <div class={{ 'remaining-quantity': index === this.dataSortingTable.length - 1 }}>
                                        <span>{data?.numberOfTasks}</span>
                                        {/* Initial input value change display */}
                                        {index === this.dataSortingTable.length - 1 &&
                                          this.isMultiSortingAndOneHunderPercentMode &&
                                          this.chuteModeType === ChuteModeType.ON &&
                                          SortingUtils.isParallelSorting &&
                                          this.checkDifferentInputQuantity() && (
                                            <span class="pl-1 quantity-changed">
                                              <i class="material-icons md-red">report</i>
                                              <span class="quantity-changed">数量が変わりました</span>
                                            </span>
                                          )}
                                      </div>
                                    </td>
                                    {SortingUtils.isParallelSorting
                                      ? [
                                          <td key="operaSign" class="operaSign">
                                            x
                                          </td>,
                                          <td key="orderUnit">{data?.orderUnit || 1}</td>,
                                          <td key="equalSign" class="operaSign">
                                            =
                                          </td>,
                                          <td key="result"> {Math.imul(data?.numberOfTasks, data?.orderUnit || 1)}</td>
                                        ]
                                      : [<td></td>, <td></td>, <td></td>, <td></td>]}
                                  </tr>
                                );
                              })}
                              {/* 100% スキャンの入力数量を表示するだけです */}
                              {this.modeType === ScanMode.ONE_HUNDRED_PERCENT_SCAN &&
                                (this.isShowMaxInputQuantity() ? (
                                  <tr>
                                    <th scope="row" class="align-middle text-left">
                                      投入数
                                    </th>
                                    <td class="text-left pl-4 py-2" colspan="2">
                                      <div class="number-of-input">{this.inputQuantity}</div>
                                    </td>
                                    <th scope="row" class="align-middle text-left">
                                      最大投入数
                                    </th>
                                    <td class="text-left" colspan="2">
                                      <div class="number-of-input">
                                        {this.maxInputQuantity}
                                        {SortingUtils.isParallelSorting && this.checkDifferentInputQuantity() && (
                                          <span class="pl-1 quantity-changed">
                                            <i class="material-icons md-red">report</i>
                                            <span class="quantity-changed">数量が変わりました</span>
                                          </span>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <th scope="row" class="align-middle text-left">
                                      投入数
                                    </th>
                                    <td class="text-left pl-4 py-2" colspan="5">
                                      <div class="number-of-input">{this.inputQuantity}</div>
                                    </td>
                                  </tr>
                                ))}
                              {this.$slots?.inputQuantity && this.displayNumericKeyboard && (
                                <tr class="bg-white">
                                  <th scope="row" class="border-0 text-left pt-3 th-label-scan-code">
                                    <TooltipComponent
                                      ref="scan-code-pattern-tooltip"
                                      customClass="field-name-scan-code-cell"
                                      idLabelEllipsis="field-name-scan-code-cell"
                                      labelEllipsis={
                                        this.modeType === ScanMode.REPRESENTATIVE_SCAN
                                          ? '投入数'
                                          : this.fieldNameScanCode
                                      }
                                    />
                                  </th>
                                  <td colspan="5" class="border-0 pt-3">
                                    {this.$slots?.inputQuantity}
                                  </td>
                                </tr>
                              )}
                              {this.modeType === ScanMode.ONE_HUNDRED_PERCENT_SCAN &&
                                this.$slots?.swipeButton &&
                                this.displayNumericKeyboard && (
                                  <tr class="bg-white">
                                    <th scope="1" class="no-border pr-0"></th>
                                    <td colspan="5" class="no-border justify-content-between">
                                      {this.$slots?.swipeButton}
                                    </td>
                                  </tr>
                                )}
                            </tbody>
                          </table>
                        </div>
                        {this.isMultiSortingAndOneHunderPercentMode && (
                          <div class="col area-btn">{this.$slots?.acceptButton}</div>
                        )}
                      </b-row>
                    </b-container>
                    {!this.displayNumericKeyboard && (
                      <b-container fluid class="input-scan-code-area">
                        <b-row>
                          <b-col>
                            <b-row>
                              <b-col cols="2" class="col-label-scan-code">
                                <TooltipComponent
                                  ref="scan-code-tooltip"
                                  idLabelEllipsis="scan-code"
                                  customClass="label-scan-code"
                                  labelEllipsis={this.fieldNameScanCode}
                                />
                              </b-col>
                              <b-col cols="7">
                                <div class="mr-3">{this.$slots?.inputQuantity}</div>
                              </b-col>
                              <b-col class="col-label-scan-code">{this.$slots?.swipeButton}</b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-container>
                    )}
                    {SortingUtils.isParallelMultiSorting && (
                      <b-container fluid class="d-flex align-items-baseline align-last-chute-no">
                        <span class="ml-2 text-size-16">前回シュートNo </span>
                        <h5 class="pl-3 last-chute-no">{this.lastChuteNo}</h5>
                      </b-container>
                    )}
                  </b-container>
                </div>
                {this.displayNumericKeyboard && <div class="col-12 col-lg-4">{this.$slots?.numericKeyboard}</div>}
              </div>
            </b-container>
          </b-modal>
        ) : null}
      </div>
    );
  }
}
